import { Flex, Input, Select, Text } from '@chakra-ui/react';
import {
  ANALYTICS_RANGE_OPTIONS,
  formatDateRangeLabel,
  getRangeOptionLabel,
} from '../../utils/dateRange';

const CardHeader = ({
  title,
  handleChange,
  value,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: {
  title: string;
  handleChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
  startDate?: string;
  endDate?: string;
  onStartDateChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEndDateChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const dateRangeLabel = value
    ? formatDateRangeLabel(value, startDate, endDate)
    : '';
  const isCustomRange = value === 'CUSTOM';

  return (
    <Flex direction='column' gap='12px' width='100%'>
      <Flex justifyContent='space-between' alignItems='center' width='100%'>
        <Flex direction='column' gap='4px'>
          <Text color='#756F86'>{title}</Text>
          {dateRangeLabel ? (
            <Text color='#A0AEC0' fontSize='12px'>
              {dateRangeLabel}
            </Text>
          ) : null}
        </Flex>
        <Select
          style={{
            border: 'none',
            outline: 'none',
            width: 'max-content',
            textAlign: 'right',
            maxWidth: '320px',
          }}
          color='#05396B'
          cursor='pointer'
          width='max-content'
          outline='none'
          onChange={handleChange}
          value={value}
        >
          {ANALYTICS_RANGE_OPTIONS.map(({ value: optionValue, label }) => (
            <option key={optionValue} value={optionValue}>
              {getRangeOptionLabel(optionValue, label, startDate, endDate)}
            </option>
          ))}
        </Select>
      </Flex>
      {isCustomRange ? (
        <Flex gap='12px' flexWrap='wrap'>
          <Flex direction='column' gap='4px' flex='1' minW='160px'>
            <Text color='#756F86' fontSize='12px'>
              Start Date
            </Text>
            <Input
              type='date'
              size='sm'
              value={startDate}
              max={endDate || undefined}
              onChange={onStartDateChange}
            />
          </Flex>
          <Flex direction='column' gap='4px' flex='1' minW='160px'>
            <Text color='#756F86' fontSize='12px'>
              End Date
            </Text>
            <Input
              type='date'
              size='sm'
              value={endDate}
              min={startDate || undefined}
              onChange={onEndDateChange}
            />
          </Flex>
        </Flex>
      ) : null}
    </Flex>
  );
};

export default CardHeader;
